import RoleAndTechSkillsReducer from "./RoleAndTechSkills/roleAndTeckSkills.reducer";
import OnboardingNewUiUxReducer from "./onboardingNewUiUx.reducer";
import EducationReducer from "./Education/Education.reducer";
import ResumeUploadReducer from "./OldResumeUpload/resumeUpload.reducer";
import BasicInformationReducer from "./BasicInformation/basicInformation.reducer";
import NewResumeUploadReducer from "./NewResumeUpload/resumeUpload.reducer";

const reducers = {
    onboarding_new_ui: OnboardingNewUiUxReducer,
    role_skills_page: RoleAndTechSkillsReducer,
    education_page: EducationReducer,
    resume_upload_page: ResumeUploadReducer,
    basic_info_page: BasicInformationReducer,
    newResumeUpload: NewResumeUploadReducer
}

export {
    reducers
}
